import { render, staticRenderFns } from "./mainbusinessPage7.vue?vue&type=template&id=9af096c0&scoped=true&"
import script from "./mainbusinessPage7.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage7.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage7.vue?vue&type=style&index=0&id=9af096c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af096c0",
  null
  
)

export default component.exports